import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import useStores from '@stores/useStores';
import { Path } from '@components/routes/constants';
import { DropdownTag } from '@components/common/dropdownTag';
import { IDestinationStore } from '@stores/destination';
import { ISourceStore } from '@stores/source';

import { useDesignVariant } from '../designVariantContext';

interface LinkedResourcesDropdownTagProps {
  accountId: string;
  resourceType: 'destination' | 'source';
}

export const LinkedResourcesDropdownTag: React.FC<LinkedResourcesDropdownTagProps> = ({
  accountId,
  resourceType,
}) => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { destinationsListStore, sourcesListStore } = useStores();
  const variant = useDesignVariant();

  const linkedResources =
    resourceType === 'destination'
      ? destinationsListStore.destinations.filter(
          (resource) => resource.config.rudderAccountId === accountId,
        )
      : sourcesListStore.sources.filter(
          (resource) => resource.config.rudderAccountId === accountId,
        );

  const sortCurrentResourceFirst = (a: { id: string }, b: { id: string }) => {
    if (a.id === id) {
      return -1;
    }

    if (b.id === id) {
      return 1;
    }

    return 0;
  };

  const mapResourceToMenuItem = (resource: IDestinationStore | ISourceStore) => ({
    key: resource.id,
    label: `${resource.name}${resource.id === id ? ' (current)' : ''}`,
    onClick: () => history.push(Path.DESTINATION_DETAILS(resource.id)),
  });

  const menuItems = linkedResources.sort(sortCurrentResourceFirst).map(mapResourceToMenuItem);

  return linkedResources.length > 0 ? (
    <DropdownTag
      variant={variant}
      placement="bottomLeft"
      label={`${linkedResources.length} Linked`}
      menuItems={menuItems}
    />
  ) : null;
};
